import { Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { REGULAR_EXPRESSION } from '../../../app.constants';
import { SubjectLocation } from '../../../_objects/subject-model';
import { CustomValidators } from '../../../_shared/custom-validator';
import { SubjectModelEditDialogComponent } from '../subject-model-edit-dialog/subject-model-edit-dialog.component';
import { UtilsService } from '../../../_services/_utils.service';

@Component({
    selector: 'app-location-abbreviation-edit-dialog',
    templateUrl: './location-abbreviation-edit-dialog.component.html',
    styleUrls: ['./location-abbreviation-edit-dialog.component.scss'],
    standalone: false
})
export class LocationAbbreviationEditDialogComponent {

  readonly maxLength = 50;

  regularExpression = this.utilsService.CombiningRegExp([
    '^',
    REGULAR_EXPRESSION.RESERVED_WORDS_PATTERN,
    '[',
    REGULAR_EXPRESSION.HALF_ALPHANUMERIC_PATTERN,
    REGULAR_EXPRESSION.KANJI_PATTERN,
    REGULAR_EXPRESSION.SYMBOL_PATTERN,
    ']+$'
  ]);

  nameControl = new FormControl<string>('', [
    CustomValidators.requiredTrimmed(),
    Validators.maxLength(this.maxLength),
    Validators.pattern(this.regularExpression)
  ]);

  abbreviationControl = new FormControl<string>('', [
    CustomValidators.requiredTrimmed(),
    Validators.maxLength(this.maxLength),
    Validators.pattern(this.regularExpression),
    this.duplicationValidator(),
    this.spaceValidator()
  ]);
  
  public subjectLocationsExceptMine: SubjectLocation[];
  public identifierPrefix: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SubjectModelEditDialogComponent>,
    public utilsService: UtilsService
  ) {
    this.subjectLocationsExceptMine = data.subjectLocationsExceptMine;
    this.identifierPrefix = data.identifierPrefix;
    this.nameControl.setValue(data.retentionLocation.name);
  }

  duplicationValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      let isDuplication = false;
      this.subjectLocationsExceptMine.forEach(location => {
        if (this.isDuplicationIdentifier(location, this.identifierPrefix + this.changeStringCase(control.value))) {
          isDuplication = true;
        }
      });
      return isDuplication ? { 'duplication': 'false' } : null;
    };
  }

  isDuplicationIdentifier(targetLoc: SubjectLocation, termLocIdentifier: string): boolean {
    let isDuplication = false;
    if (this.changeStringCase(targetLoc.identifier) === this.changeStringCase(termLocIdentifier)) {
      isDuplication = true;
    }
    if (targetLoc.children && targetLoc.children.length > 0) {
      targetLoc.children.forEach(location => {
        if (this.isDuplicationIdentifier(location, this.changeStringCase(termLocIdentifier))) {
          isDuplication = true;
        }
      });
    }
    return isDuplication;
  }

  changeStringCase(value: string): string {
    return value.toLowerCase();
  }

  // 空白文字(半角スペース/タブ/改行/改ページ)、全角スペースがあるか判定
  spaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const isSpace = REGULAR_EXPRESSION.SPACE_PATTERN.test(control.value);
      return isSpace ? { 'space': 'false' } : null;
    };
  }

  submit() {
    this.dialogRef.close({
      name: this.nameControl.value,
      abbreviation: this.abbreviationControl.value
    });
  }
}
